import ActionMenu from "../Actions/ActionMenu";

export const ReportColumn = (handleEdit,handleDelete,userData) => [

  // { name: "#", selector: (row, index) => index + 1, width: "60px", sortable: false },
  { name: ( <> Report No </> ), selector: (row) => row.reptNo, sortable: true, wrap: true },
  { name: ( <> Report Date </> ), selector: (row) => row.reptDate, sortable: true, wrap: true },
  { name: ( <> Report </> ), selector: (row) => row.reptName, sortable: true, wrap: true },
  { name: ( <> Patient Name </> ), selector: (row) => row.mrdName, sortable: true, wrap: true },
  { name: ( <> QID </> ), selector: (row) => row.userName, sortable: true, wrap: true },
  { name: ( <> Ref Dr </> ), selector: (row) => row.refDr, sortable: true, wrap: true },
  { name: ( <> Ref Clinic </> ), selector: (row) => row.refClinic, sortable: true, wrap: true },
  { name: ( <> Mrd No </> ), selector: (row) => row.mrdNo, sortable: true, wrap: true },
{
    name: "Actions",
    cell: row => (
      <ActionMenu 
        // onEdit={() => handleEdit(row)}
        onDelete={() => handleDelete(row)}
      />
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    // button: true,
    omit: userData?.userAdmin=='N'?true:false
  }
];
export const UsersColumn = (handleEdit,handleDelete) => [

  // { name: "#", selector: (row, index) => index + 1, width: "60px", sortable: false },
  { name: ( <> User Name </> ), selector: (row) => row.userName, sortable: true, wrap: true },
  { name: ( <> User Admin </> ), selector: (row) => row.userAdmin, sortable: true, wrap: true },
  { name: ( <> User type </> ), selector: (row) => row.userType, sortable: true, wrap: true },
  {
    name: "Actions",
    cell: row => (
      <ActionMenu
        onEdit={() => handleEdit(row)}
        onDelete={() => handleDelete(row)}
      />
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    // button: true,
  }
];